<hhsg-message-bar [messages]="saveSuccessText" [visibilityTimeout]="5" [isError]="false"></hhsg-message-bar>
<hhsg-page-header headerText="Users Summary" [subHeaderText]="" [showBreadCrumb]="false" class="admin-header" *ngIf="isAppHap() || displayHeader">
  <dx-select-box #corporation
                 [(dataSource)]="corporations"
                 displayExpr="name"
                 valueExpr="id"
                 label="Corporation"
                 [disabled]="!viewCorporations()"
                 (onValueChanged)="onCorporationChanged()"
                 [(value)]="selectedCorporationId"
                 width="300px"
                 [stylingMode]="dxStylingMode"
                 ngDefaultControl
                 [searchEnabled]="true">
  </dx-select-box>

  <div class="application-filter" *ngIf="!isAppHap()">
    <dx-check-box [(value)]="filterByCurrentApplication" (onValueChanged)="toggleFilterByCurrentApplication()" ngDefaultControl></dx-check-box>
    <div class="label">Filter by Current Application</div>
  </div>
  <div header-buttons>
    <div class="button-grp">
      <button id="add-new-aka" class="btn-secondary" (click)="exportToExcel();">
        Export to Excel
      </button>
      <button id="clear-new-aka" class="btn-secondary" (click)="addUser();" [disabled]="!selectedCorporationId || selectedCorporationId === -1">
        New User
      </button>
    </div>
  </div>
</hhsg-page-header>
<div class="content-inner">
<dx-data-grid #usersGrid (onContentReady)="setTableHeaderStyle()"
    (onOptionChanged)="onOptionChanged($event)" id="usersGrid" [remoteOperations]="true"
    [dataSource]="corporationUsersDataStore" [showColumnLines]="false" [wordWrapEnabled]="true"
    [columnAutoWidth]="true" [noDataText]="'Sorry, no users were found that matched your search.'"
    style="min-width:100%;" [columnHidingEnabled]="true" [rowAlternationEnabled]="true">
    <dxo-paging [pageSize]="25"></dxo-paging>
    <dxo-export fileName="{{getFileName()}}"></dxo-export>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-pager [showPageSizeSelector]="true" [visible]="true" [allowedPageSizes]="[25, 50, 100]"
        [showInfo]="true">
    </dxo-pager>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxi-column [width]="50" cellTemplate="editCellTemplate" [allowSorting]="false"></dxi-column>
    <dxi-column dataField="fullName" caption="Name" dataType="string" [allowHeaderFiltering]="false" sortOrder="asc"
                    calculateSortValue="lastName" minWidth="110">
	</dxi-column>
    <dxi-column dataField="email" caption="Email" dataType="string" [allowHeaderFiltering]="false"
        minWidth="120"></dxi-column>
    <dxi-column dataField="clientNames" dataType="string" caption="Client" [allowFiltering]="false"
        [allowHeaderFiltering]="true" minWidth="250">
		<dxo-header-filter [dataSource]="clientNamesFilter"></dxo-header-filter>
    </dxi-column>
    <dxi-column dataField="applicationAbbreviations" dataType="string" caption="Applications"
        [allowFiltering]="false" [allowHeaderFiltering]="true" minWidth="250">
		<dxo-header-filter [dataSource]="applicationAbbreviationFilter"></dxo-header-filter>
    </dxi-column>
	<dxi-column dataField="statusText" dataType="string" caption="Status" [allowFiltering]="false"
        minWidth="200" [allowHeaderFiltering]="true"></dxi-column>
    <dxi-column dataField="roleName" dataType="string" caption="Role" [allowFiltering]="false"
        [allowHeaderFiltering]="true" minWidth="95"></dxi-column>
    <dxi-column dataField="modifiedDate" caption="Last Modified" dataType="date"
        format='MM/dd/yyyy h:mm:ss a' [allowHeaderFiltering]="false" minWidth="200"></dxi-column>
    <div *dxTemplate="let data of 'editCellTemplate'">
        <a class="edit" [hidden]="!data.data.canUpdateUser" (click)="onEditUser(data.data.userId)">
            <span class="material-symbols-outlined cursor-pointer">edit</span>
        </a>
    </div>
    <dxi-column dataField="modifiedByUserName" caption="Last Modified By" dataType="string"
        [allowHeaderFiltering]="false" minWidth="120"></dxi-column>
    <div *dxTemplate="let data of 'reEnableCellTemplate'">
        <div [ngSwitch]="data.data.statusText">
            <div *ngSwitchCase="userStatusDormant">
                <a (click)="onEnableUser(data.data.userId, 're-enable')">
                    <span class="icon-switch"></span></a>
            </div>
            <div *ngSwitchCase="userStatusLocked">
                <a (click)="onEnableUser(data.data.userId, 'unlock')">
                    <span class="icon-blocked"></span></a>
            </div>
            <div *ngSwitchDefault></div>
        </div>
    </div>
    <div *dxTemplate="let data of 'statusIconTemplate'" class="status">
        <span [title]="data.data.upsertStatusText"
            [ngClass]="{'icon-check-circle sync-success': data.data.upsertStatusText =='Synced','icon-warning-circle sync-error': data.data.upsertStatusText =='Failed'  }"></span>
    </div>
</dx-data-grid>
</div>

